import React, { useEffect, useState } from 'react'
import TutorHeader from '../TutorHeader/TutorHeader'
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import TutorFooter from '../TutorFooter/TutorFooter'
import { Link } from 'react-router-dom'
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import { getTutorQueriesDetailData, getTutorQueryListData } from '../../../Redux/action/TutorAction'
import { useDispatch, useSelector } from 'react-redux'
import Beatloader from '../../../Common/BeatLoader'
import { Modal, ModalBody, ModalHeader, ModalTitle } from 'react-bootstrap'
import HourglassLoader from '../../../Common/HourglassLoader'
import ResponsivePagination from '../../../Common/Pagination'

const host = process.env.REACT_APP_API_SERVER
const TutorStudentQueries = () => {
    const [showModal, setShowModal] = useState(false)
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getTutorQueryListData());

    }, []);

    const handleViewQuery = (id) => {

        dispatch(getTutorQueriesDetailData(id));
        setShowModal(true)
    }


    const {

        loadingTutorQueryListApi,
        TutorQueryListApiData,
        TutorQueryListApiError,

        loadingTutorQueriesDetailApi,
        TutorQueriesDetailApiData,
        TutorQueriesDetailApiError

    } = useSelector(state => state?.TutorReducer);



    let [initialValues, setInitialValues] = useState({
        query_id: "",
        answer: "",



    })

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({

            answer: Yup.string().required("Answer is required."),


        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {

            try {


                setSubmitting(true);
                let config = {
                    headers: {
                        "x-auth-token": localStorage.getItem('tutor-token'),

                    },
                };

                await axios.post(`${host}/api/tutor/student-query/${TutorQueriesDetailApiData?.id}`, values, config)
                    .then(function (response) {

                        if (response.status == 200) {
                            setSubmitting(false)

                            toast.success('Your answer submitted successfully');
                            resetForm();
                            setShowModal(false);
                            dispatch(getTutorQueryListData());
                        } else {

                            setSubmitting(false)

                            toast.error(response.data.message);

                        }

                    })
                    .catch(function (error) {


                        setSubmitting(false)
                        toast.error('Error submitting form. Please try again.');

                    })

            }
            catch (error) {


                setSubmitting(false)
                toast.error('Error submitting form. Please try again.');

            }

        }
    });






    //pagination
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1); // ✅ 1-based page index
    const dataPerPage = 10;

    useEffect(() => {
        if (!TutorQueryListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(TutorQueryListApiData.slice(start, end));
        setPageCount(Math.ceil(TutorQueryListApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, TutorQueryListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };
    useEffect(() => {

        if (TutorQueriesDetailApiData) {
            formik.setValues({
                query_id: TutorQueriesDetailApiData?.id ?? "",
                answer: TutorQueriesDetailApiData?.answer ?? "",
            })
        }
    }, [TutorQueriesDetailApiData])

    return (
        <div className='pagination-component'>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Student Queries
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                {loadingTutorQueryListApi ?
                                    <Beatloader />
                                    :
                                    <div className="row">
                                        {TutorQueryListApiData?.length > 0 ?
                                            currentData?.map((data) => (
                                                <div className="col-lg-6 col-md-6 mt-4">
                                                    <div
                                                        className="card student-query-card btn"
                                                        onClick={() => { handleViewQuery(data?.id) }}
                                                    >
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="col-lg-3">
                                                                    <img
                                                                        src={`${host}${data?.student?.profile_img}`}
                                                                        onError={(e) => {

                                                                            e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                        }}
                                                                        className="img-fluid" />
                                                                </div>
                                                                <div className="col-lg-6">
                                                                    <div className="student-queries-details">
                                                                        <h4 className="mb-0 student-name text-start">{data?.student?.name}</h4>
                                                                        <p className="mb-0 course-name text-start">
                                                                            <span>Course Name:</span>
                                                                            <sapn>{data?.course?.name}</sapn>
                                                                        </p>
                                                                        <p className="mb-0 course-name text-start">
                                                                            <span>Query Title:</span>
                                                                            <sapn>{data?.title}</sapn>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3">
                                                                    <p className="mb-0 text-primary date">{new Date(data?.createdAt).toISOString().split('T')[0]}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                            :
                                            <div className='no-data-img'>
                                                <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                            </div>}

                                        {pageCount > 1 && (
                                            <ResponsivePagination
                                                pageCount={pageCount}
                                                currentPage={currentPage}
                                                handlePageClick={handlePageClick}
                                            />
                                        )}
                                    </div>}
                            </main>



                        </div>
                    </div>
                </div>
            </section>

            <>
                {/* Modal Section Start */}
                <Modal
                    className="modal modal-student-queries fade"
                    id="queriesModal"
                    tabIndex={-1}
                    show={showModal}
                    onHide={() => setShowModal(false)}
                >

                    <ModalHeader closeButton>
                        <ModalTitle className=" text-primary">
                            Solve Queries
                        </ModalTitle>

                    </ModalHeader>
                    <ModalBody>
                        {loadingTutorQueriesDetailApi ?
                            <Beatloader />
                            :
                            <form onSubmit={formik.handleSubmit}>
                                <label htmlFor="">Student Name</label>
                                <br />
                                <input
                                    hidden
                                    name='query_id'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.query_id}

                                />
                                <input
                                    type="text"
                                    placeholder="Deepak Kumar"
                                    className="w-100 px-2 py-2"
                                    readOnly
                                    value={TutorQueriesDetailApiData?.student?.name}
                                />
                                <label htmlFor="">Course name</label>
                                <br />
                                <input
                                    type="text"
                                    placeholder="test group course"
                                    className="w-100 px-2 py-2"
                                    readOnly
                                    value={TutorQueriesDetailApiData?.course?.name}
                                />
                                <label htmlFor="">Title</label>
                                <br />
                                <input
                                    type="text"
                                    placeholder="doubt"
                                    className="w-100 px-2 py-2"
                                    readOnly
                                    value={TutorQueriesDetailApiData?.title}
                                />
                                <label htmlFor="">Doubt Description</label>
                                <br />
                                <textarea className="w-100 border-0" readOnly defaultValue={TutorQueriesDetailApiData?.doubt_description} />
                                <label>Answer<span className='text-danger'>*</span></label>
                                <br />
                                <textarea className="w-100 border-0" name='answer'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.answer}

                                    readOnly={TutorQueriesDetailApiData?.answer}
                                />
                                <div className="help-block with-errors">
                                    {formik.touched.answer && formik.errors.answer ? (
                                        <div className='text-danger'>{formik.errors.answer}</div>
                                    ) : null}
                                </div>

                                {!TutorQueriesDetailApiData?.answer &&
                                    <button disabled={formik.isSubmitting} type="submit" className="btn btn-primary btn-submit">

                                        {formik.isSubmitting ? <HourglassLoader /> : 'Submit'}
                                    </button>}
                            </form>}
                    </ModalBody>


                </Modal>
            </>

        </div>
    )
}

export default TutorStudentQueries